import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProgressTracker } from '@app/booking/booking.types';

export interface status {
  name: string;
  description?: string;
  progress: number; // 0 didn't start - 100 completed
}

// export interface TrackerConfiguration {
//   estimatedDeliveryTime?: Date;
//   statuses: status[];
//   datePlaceHolder?: string;
//   hideEstimatedDeliveryTime?: boolean;
//   originalDeliveryTime?: Date;
// }

@Component({
  selector: 'ahoy-tracker',
  templateUrl: './ahoy-tracker.component.html',
  styleUrls: ['./ahoy-tracker.component.scss'],
  standalone: false,
})
export class AhoyTrackerComponent implements OnInit {
  @Input() configuration: ProgressTracker | undefined;
  currentStatus: string = '';

  constructor() {}

  ngOnInit(): void {
    const stages = this.configuration?.stages ?? [];
    const lastCompletedStage = [...stages]
      .reverse()
      .find((s) => s.progress === 2);
    this.currentStatus = lastCompletedStage?.title ?? '';
  }
}
